import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuditingComponent } from '@flowinn/components/auditing/auditing.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateDirective } from '@language/translate.directive';
import { BlockUIModule } from 'ng-block-ui';

@Component({
  selector: 'flw-edit',
  templateUrl: './edit.component.html',
  imports: [BlockUIModule, NgClass, ReactiveFormsModule, FontAwesomeModule, AuditingComponent, TranslateDirective, NgIf],
  standalone: true,
})
export class EditComponent {
  @Input() record?: any;
  @Input() pageName: string | undefined;
  @Input() editForm: any;
  @Input() showFooter = true;
  @Input() showSave = true;
  @Input() showCardHeader = true;
  @Input() showHeader = true;
  @Input() showBack = true;
  @Input() showInline = false;
  @Input() withoutPadding = false;
  @Input() bodyClass: string | undefined;
  @Input() isSaving = false;
  @Output() previousState: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  constructor() {}

  previous($event: MouseEvent): void {
    this.previousState.emit($event);
  }

  saveForm(): void {
    this.save.emit();
  }
}
